import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

if (typeof window !== "undefined" && "ResizeObserver" in window) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => {
          callback(entries, observer);
        });
      });
    }
  };
}

const originalConsoleError = console.error.bind(console);
console.error = (...args) => {
  const message = args
    .map((arg) => (typeof arg === "string" ? arg : arg?.message || ""))
    .join(" ");
  if (
    message.includes("ResizeObserver loop completed") ||
    message.includes("ResizeObserver loop limit exceeded")
  ) {
    return;
  }
  originalConsoleError(...args);
};

const originalWindowError = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  const text = typeof message === "string" ? message : error?.message || "";
  if (
    text.includes("ResizeObserver loop completed") ||
    text.includes("ResizeObserver loop limit exceeded")
  ) {
    return true;
  }
  if (typeof originalWindowError === "function") {
    return originalWindowError(message, source, lineno, colno, error);
  }
  return false;
};

window.addEventListener("error", (event) => {
  const message = event.message || "";
  if (
    message.includes("ResizeObserver loop completed") ||
    message.includes("ResizeObserver loop limit exceeded")
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
